import {
  VoiceboxResponseAction,
  VoiceboxResponseActionType,
} from 'vet-bones/constants/voicebox';
import {
  ModelingAndMappingAction,
  ModelingAndMappingActionType,
} from 'vet-bones/utils/voicebox';

export const ADD_PERSON_ACTION: ModelingAndMappingAction = {
  type: ModelingAndMappingActionType.CREATE_MODEL_CONCEPT_CLASS,
  data: {
    iri: 'urn:example:Person',
    label: 'Person',
    description: 'Person description',
  },
};

export const ADD_ORGANIZATION_ACTION: ModelingAndMappingAction = {
  type: ModelingAndMappingActionType.CREATE_MODEL_CONCEPT_CLASS,
  data: {
    iri: 'urn:example:Organization',
    label: 'Organization',
    description: 'Organization description',
  },
};

export const ADD_BELONGS_TO_ACTION: ModelingAndMappingAction = {
  type: ModelingAndMappingActionType.CREATE_MODEL_CONCEPT_RELATIONSHIP,
  data: {
    iri: 'urn:example:belongs_to',
    label: 'Belongs To',
    description: 'Belongs To description',
    domains: ['urn:example:Person'],
    ranges: ['urn:example:Organization'],
  },
};

export const ADD_NAME_ACTION: ModelingAndMappingAction = {
  type: ModelingAndMappingActionType.CREATE_MODEL_CONCEPT_ATTRIBUTE,
  data: {
    iri: 'urn:example:name',
    label: 'Name',
    description: 'Name description',
    domains: ['urn:example:Person', 'urn:example:Organization'],
    ranges: ['http://www.w3.org/2001/XMLSchema#string'],
  },
};

export const UPDATE_PERSON_ACTION: ModelingAndMappingAction = {
  type: ModelingAndMappingActionType.UPDATE_MODEL_CONCEPT_CLASS,
  data: {
    iri: 'urn:example:Person',
    label: 'Updated Person',
  },
};

export const UPDATE_ORGANIZATION_ACTION: ModelingAndMappingAction = {
  type: ModelingAndMappingActionType.UPDATE_MODEL_CONCEPT_CLASS,
  data: {
    iri: 'urn:example:Organization',
    description: 'Updated Organization description',
  },
};

export const UPDATE_BELONGS_TO_ACTION: ModelingAndMappingAction = {
  type: ModelingAndMappingActionType.UPDATE_MODEL_CONCEPT_RELATIONSHIP,
  data: {
    iri: 'urn:example:belongs_to',
    domains: ['urn:example:Person'],
    ranges: ['urn:example:Organization'],
  },
};

export const UPDATE_NAME_ACTION: ModelingAndMappingAction = {
  type: ModelingAndMappingActionType.UPDATE_MODEL_CONCEPT_ATTRIBUTE,
  data: {
    iri: 'urn:example:name',
    domains: ['urn:example:Person', 'urn:example:Organization'],
    ranges: ['http://www.w3.org/2001/XMLSchema#boolean'],
  },
};

export const DELETE_PERSON_ACTION: ModelingAndMappingAction = {
  type: ModelingAndMappingActionType.DELETE_MODEL_CONCEPT_CLASS,
  data: {
    iri: 'urn:example:Person',
  },
};

export const DELETE_ORGANIZATION_ACTION: ModelingAndMappingAction = {
  type: ModelingAndMappingActionType.DELETE_MODEL_CONCEPT_CLASS,
  data: {
    iri: 'urn:example:Organization',
  },
};

export const DELETE_BELONGS_TO_ACTION: ModelingAndMappingAction = {
  type: ModelingAndMappingActionType.DELETE_MODEL_CONCEPT_RELATIONSHIP,
  data: {
    iri: 'urn:example:belongs_to',
  },
};

export const DELETE_NAME_ACTION: ModelingAndMappingAction = {
  type: ModelingAndMappingActionType.DELETE_MODEL_CONCEPT_ATTRIBUTE,
  data: {
    iri: 'urn:example:name',
  },
};

export const DESIGNER_REQUEST_EXAMPLES = [
  'Add all concepts',
  'Add concepts Person and Organization',
  'Create a relationship where a Person belongs to an Organization',
  'Update all concepts',
  'Remove Organization from Belongs To range',
  'Remove all concepts',
  'Remove concept Person',
  'Request with invalid response actions',
  'Request with no response actions',
];

export const DESIGNER_RESPONSE_MESSAGES: Record<string, string> =
  Object.fromEntries(
    [
      'Added all concepts',
      'Added concepts [Person](urn:example:Person) and [Organization](urn:example:Organization)',
      'Added relationship [belongs to](urn:example:belongs_to)',
      'Updated all concepts',
      'Updated concept [belongs to](urn:example:belongs_to)',
      'Removed all concepts',
      'Removed concept [Person](urn:example:Person)',
      'Response containing invalid JSON',
    ].map((value, idx) => [DESIGNER_REQUEST_EXAMPLES[idx], value])
  );

export const DESIGNER_RESPONSE_ACTIONS: Record<
  string,
  VoiceboxResponseAction[]
> = Object.fromEntries(
  [
    [
      {
        type: VoiceboxResponseActionType.MODELING_AND_MAPPING,
        value: JSON.stringify({
          version: 1,
          actions: [
            ADD_PERSON_ACTION,
            ADD_ORGANIZATION_ACTION,
            ADD_BELONGS_TO_ACTION,
            ADD_NAME_ACTION,
          ],
        }),
      },
    ],
    [
      {
        type: VoiceboxResponseActionType.MODELING_AND_MAPPING,
        value: JSON.stringify({
          version: 1,
          actions: [ADD_PERSON_ACTION, ADD_ORGANIZATION_ACTION],
        }),
      },
    ],
    [
      {
        type: VoiceboxResponseActionType.MODELING_AND_MAPPING,
        value: JSON.stringify({
          version: 1,
          actions: [ADD_BELONGS_TO_ACTION],
        }),
      },
    ],
    [
      {
        type: VoiceboxResponseActionType.MODELING_AND_MAPPING,
        value: JSON.stringify({
          version: 1,
          actions: [
            UPDATE_PERSON_ACTION,
            UPDATE_ORGANIZATION_ACTION,
            UPDATE_BELONGS_TO_ACTION,
            UPDATE_NAME_ACTION,
          ],
        }),
      },
    ],
    [
      {
        type: VoiceboxResponseActionType.MODELING_AND_MAPPING,
        value: JSON.stringify({
          version: 1,
          actions: [UPDATE_NAME_ACTION],
        }),
      },
    ],
    [
      {
        type: VoiceboxResponseActionType.MODELING_AND_MAPPING,
        value: JSON.stringify({
          version: 1,
          actions: [
            DELETE_PERSON_ACTION,
            DELETE_ORGANIZATION_ACTION,
            DELETE_BELONGS_TO_ACTION,
            DELETE_NAME_ACTION,
          ],
        }),
      },
    ],
    [
      {
        type: VoiceboxResponseActionType.MODELING_AND_MAPPING,
        value: JSON.stringify({
          version: 1,
          actions: [DELETE_PERSON_ACTION],
        }),
      },
    ],
    [
      {
        type: VoiceboxResponseActionType.MODELING_AND_MAPPING,
        value: '',
      },
    ],
  ].map((value, idx) => [DESIGNER_REQUEST_EXAMPLES[idx], value])
);
